/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
//Standard libraries
import React from "react";
import { Link } from "react-router-dom";
import {
  Divider,
  Grid,
  Switch,
  Typography,
  FormControlLabel,
} from "@material-ui/core";
//custom libraries
import { useCustomerSearchForm } from "../hooks/use-customer-search-form";
import SearchFilterChipsSidebar from "./search-filter-chips-sidebar";
import { Button, BackButton } from "../components";
import TextField from "@material-ui/core/TextField";
import * as ROUTES from "./../constants/routes";

import { SEARCHCHIPS } from "../constants/search-chips";
import styled from "styled-components";

const StyledGridContainer = styled(Grid)`
  margin-bottom: 30px;
  margin-left: 0px;
  display: "flex";
  button {
    height: 40px;
    width: 116px;
    margin-left: 8px;
  }
`;

export default function CustomerSearchForm() {
  const {
    clickSearch,
    handleChange,
    toggleAdvanceSearch,
    advancedSearch,
    chips,
    removeChip,
    t,
    formError,
    customerParameter,
    setShowForm,
    showForm,
  } = useCustomerSearchForm();

  return showForm ? (
    <Grid container direction="column" spacing={2}>
      <Grid item>
        <Link to={ROUTES.DASHBOARD}>
          <BackButton label={t("Common.BackToLanding")} />
        </Link>
      </Grid>

      <Grid item>
        <Typography variant="h1">{t("Customer.CustomerSearch")} </Typography>
      </Grid>
      <Grid item>
        <FormControlLabel
          control={
            <Switch
              checked={advancedSearch}
              onChange={(e) => toggleAdvanceSearch(e)}
              color="primary"
              name="checkedB"
              inputProps={{ "aria-label": "primary checkbox" }}
            />
          }
          label={
            <Typography variant="button" color="primary">
              {t("OrderManagement.AdvancedSearch")}
            </Typography>
          }
        />
      </Grid>
      {!advancedSearch && (
        <StyledGridContainer container spacing={3}>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              label={t("Customer.LoginID")}
              onChange={(e: any) => handleChange(e)}
              type="text"
              id="logonId"
              name="logonId"
              fullWidth
              value={customerParameter.logonId}
              error={!!formError.logonId}
              helperText={!!formError.logonId && t("Common.InvalidInput")}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              label={t("Customer.EmailAddress")}
              onChange={(e: any) => handleChange(e)}
              type="text"
              id="email1"
              name="email1"
              fullWidth
              value={customerParameter.email1}
              error={!!formError.email1}
              helperText={!!formError.email1 && t("Common.InvalidInput")}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              label={t("Customer.LastName")}
              onChange={(e: any) => handleChange(e)}
              type="text"
              id="lastName"
              name="lastName"
              fullWidth
              value={customerParameter.lastName}
              error={!!formError.lastName}
              helperText={!!formError.lastName && t("Common.InvalidInput")}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              label={t("Customer.ZipCode")}
              onChange={(e: any) => handleChange(e)}
              type="text"
              id="zipcode"
              name="zipcode"
              fullWidth
              value={customerParameter.zipcode}
              error={!!formError.zipcode}
              helperText={!!formError.zipcode && t("Common.InvalidInput")}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              label={t("Customer.PhoneNumber")}
              onChange={(e: any) => handleChange(e)}
              type="text"
              id="phone1"
              name="phone1"
              fullWidth
              value={customerParameter.phone1}
              error={!!formError.phone1}
              helperText={!!formError.phone1 && t("Common.InvalidInput")}
            />
          </Grid>
        </StyledGridContainer>
      )}
      {advancedSearch && (
        <>
          <StyledGridContainer container spacing={3}>
            <Grid item xs={12} sm={6} md={4}>
              <TextField
                label={t("Customer.LoginID")}
                onChange={(e: any) => handleChange(e)}
                type="text"
                id="logonId"
                name="logonId"
                fullWidth
                value={customerParameter.logonId}
                error={!!formError.logonId}
                helperText={!!formError.logonId && t("Common.InvalidInput")}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <TextField
                label={t("Customer.FirstName")}
                onChange={(e: any) => handleChange(e)}
                type="text"
                id="firstName"
                name="firstName"
                fullWidth
                value={customerParameter.firstName}
                error={!!formError.firstName}
                helperText={!!formError.firstName && t("Common.InvalidInput")}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <TextField
                label={t("Customer.LastName")}
                onChange={(e: any) => handleChange(e)}
                type="text"
                id="lastName"
                name="lastName"
                fullWidth
                value={customerParameter.lastName}
                error={!!formError.lastName}
                helperText={!!formError.lastName && t("Common.InvalidInput")}
              />
            </Grid>
          </StyledGridContainer>
          <Grid item>
            <Typography variant="h3">
              {t("Customer.SearchbyContactDetails")}
            </Typography>
          </Grid>
          <StyledGridContainer container spacing={3}>
            <Grid item xs={12} sm={6} md={4}>
              <TextField
                label={t("Customer.EmailAddress")}
                onChange={(e: any) => handleChange(e)}
                type="text"
                id="email1"
                name="email1"
                fullWidth
                value={customerParameter.email1}
                error={!!formError.email1}
                helperText={!!formError.email1 && t("Common.InvalidInput")}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <TextField
                label={t("Customer.PhoneNumber")}
                onChange={(e: any) => handleChange(e)}
                type="text"
                id="phone1"
                name="phone1"
                fullWidth
                value={customerParameter.phone1}
                error={!!formError.phone1}
                helperText={!!formError.phone1 && t("Common.InvalidInput")}
              />
            </Grid>
          </StyledGridContainer>
          <Grid item>
            <Typography variant="h3">
              {t("Customer.SearchbyAddress")}
            </Typography>
          </Grid>
          <StyledGridContainer container spacing={3}>
            <Grid item xs={12} sm={6} md={4}>
              <TextField
                label={t("Customer.StreetAddress")}
                onChange={(e: any) => handleChange(e)}
                type="text"
                id="address1"
                name="address1"
                fullWidth
                value={customerParameter.address1}
                error={!!formError.address1}
                helperText={!!formError.address1 && t("Common.InvalidInput")}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <TextField
                label={t("Customer.ZipCode")}
                onChange={(e: any) => handleChange(e)}
                type="text"
                id="zipcode"
                name="zipcode"
                fullWidth
                value={customerParameter.zipcode}
                error={!!formError.zipcode}
                helperText={!!formError.zipcode && t("Common.InvalidInput")}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <TextField
                label={t("Customer.State")}
                onChange={(e: any) => handleChange(e)}
                type="text"
                id="state"
                name="state"
                fullWidth
                value={customerParameter.state}
                error={!!formError.state}
                helperText={!!formError.state && t("Common.InvalidInput")}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <TextField
                label={t("Customer.Country")}
                onChange={(e: any) => handleChange(e)}
                type="text"
                id="country"
                name="country"
                fullWidth
                value={customerParameter.country}
                error={!!formError.country}
                helperText={!!formError.country && t("Common.InvalidInput")}
              />
            </Grid>
          </StyledGridContainer>
        </>
      )}
      <StyledGridContainer>
        <Grid item>
          <Button
            fullWidth
            disabled={formError && Object.keys(formError).length > 0}
            onClick={(e: any) => {
              clickSearch(e);
              setShowForm(false);
            }}
            name="Search">
            {t("OrderManagement.Search")}
          </Button>
        </Grid>
      </StyledGridContainer>
    </Grid>
  ) : (
    <SearchFilterChipsSidebar
      chips={chips}
      showForm={showForm}
      setShowForm={setShowForm}
      name={t("Customer.CustomerSearch")}
      removeChip={removeChip}
      chipTextMap={SEARCHCHIPS.customerSearch}
    />
  );
}
